import React, {useState, useEffect} from 'react';
import cx from 'classnames';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import {isEmpty} from 'lodash';

const styles = (customStyles) => ({
  control: (styles, {isDisabled}) => ({
    ...styles,
    borderRadius: 0,
    borderColor: '#ced4da',
    backgroundColor: isDisabled ? '#e9ecef' : 'white',
    minHeight: '34px',
  }),
  option: (styles) => ({...styles, borderRadius: 0}),
  input: (styles) => styles,
  placeholder: (styles) => styles,
  singleValue: (styles) => styles,
  menu: (styles) => ({...styles, zIndex: 5}),
  dropdownIndicator: (styles) => ({...styles, padding: '6px'}),
  ...customStyles,
});

const SelectBase = (props) => {
  const {
    customStyles,
    className,
    defaultValue,
    value,
    onChange,
    required = false,
    isDisabled = false,
    ...rest
  } = props;
  // Setting for validation
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  useEffect(() => {
    setSelectedValue(value || defaultValue);
  }, [value]);

  const _className = cx(className, {
    'react-select--valid':
      required && !isDisabled ? !isEmpty(selectedValue) : !isDisabled,
    'react-select--invalid':
      required && !isDisabled ? isEmpty(selectedValue) : false,
  });

  function handleChange(selected) {
    setSelectedValue(selected);
    if (onChange) onChange(selected);
  }

  return (
    <Select
      value={selectedValue}
      styles={styles(customStyles)}
      className={_className}
      onChange={handleChange}
      required={required}
      isDisabled={isDisabled}
      defaultValue={defaultValue}
      {...rest}
    />
  );
};

SelectBase.defaultProps = {
  className: 'react-select-container',
  classNamePrefix: 'react-select',
  menuPlacement: 'auto',
};

const SelectSearchBase = (props) => {
  const {
    customStyles,
    required,
    className,
    defaultValue,
    value,
    onChange,
    isDisabled = false,
    ...rest
  } = props;
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  useEffect(() => {
    setSelectedValue(defaultValue || value);
  }, [value]);

  function handleChange(selected) {
    setSelectedValue(selected);
    if (onChange) onChange(selected);
  }

  const _className = cx(className, {
    'react-select--valid':
      required && !isDisabled ? !isEmpty(selectedValue) : !isDisabled,
    'react-select--invalid':
      required && !isDisabled ? isEmpty(selectedValue) : false,
  });

  return (
    <Select
      value={selectedValue}
      styles={styles(customStyles)}
      onChange={handleChange}
      className={_className}
      required={required}
      isDisabled={isDisabled}
      {...rest}
    />
  );
};

SelectSearchBase.defaultProps = {
  className: 'react-select-container',
  classNamePrefix: 'react-select',
  menuPlacement: 'auto',
  components: {
    DropdownIndicator: () => null,
    IndicatorSeparator: () => null,
  },
};

const SelectAsyncBase = (props) => {
  const {
    customStyles,
    className,
    defaultValue,
    onChange,
    required,
    isDisabled = false,
    ...rest
  } = props;
  // Setting for validation
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  const _className = cx(className, {
    'react-select--valid':
      required && !isDisabled ? !isEmpty(selectedValue) : !isDisabled,
    'react-select--invalid':
      required && !isDisabled ? isEmpty(selectedValue) : false,
  });

  function handleChange(selected) {
    setSelectedValue(selected);
    if (onChange) onChange(selected);
  }

  return (
    <AsyncSelect
      className={_className}
      onChange={handleChange}
      styles={styles(customStyles)}
      required={required}
      isDisabled={isDisabled}
      {...rest}
    />
  );
};

SelectAsyncBase.defaultProps = {
  className: 'react-select-container',
  classNamePrefix: 'react-select',
  menuPlacement: 'auto',
};

const SelectSearchAsyncBase = (props) => {
  const {
    customStyles,
    required,
    className,
    defaultValue,
    onChange,
    isDisabled = false,
    ...rest
  } = props;
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  function handleChange(selected) {
    setSelectedValue(selected);
    if (onChange) onChange(selected);
  }

  const _className = cx(className, {
    'react-select--valid':
      required && !isDisabled ? !isEmpty(selectedValue) : !isDisabled,
    'react-select--invalid':
      required && !isDisabled ? isEmpty(selectedValue) : false,
  });

  return (
    <AsyncSelect
      onChange={handleChange}
      styles={styles(customStyles)}
      className={_className}
      required={required}
      isDisabled={isDisabled}
      defaultValue={defaultValue}
      {...rest}
    />
  );
};

SelectSearchAsyncBase.defaultProps = {
  className: 'react-select-container',
  classNamePrefix: 'react-select',
  menuPlacement: 'auto',
  components: {
    DropdownIndicator: () => null,
    IndicatorSeparator: () => null,
  },
};

export {SelectBase, SelectSearchBase, SelectAsyncBase, SelectSearchAsyncBase};
